<template>
  <div class="my-area-nav">
    <ix-router-link to="/my-area/collections">{{ $nippets.myarea.collections }}</ix-router-link>
    <ix-router-link to="/my-area/account">{{ $nippets.myarea.account }}</ix-router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.my-area-nav{
  font-size:23px;
  margin-bottom:25px;
  font-weight:500;
}

.my-area-nav a{
  color:#a7aba1;
  display:inline-block;
  margin-right:25px;
}

.my-area-nav a:hover{
  color:#ce0e2d;
}

.my-area-nav a.router-link-active:hover{
  color:#ce0e2d;
}

.my-area-nav a.router-link-active{
  color:#000;
}
</style>